import MultipleAvatars from 'components/MultipleAvatars';
import { ICON_SIZES } from 'common/constants/sizes';
import { StyledMembersCell } from './Cells.style';

const MembersCell = ({ contributors = {}, contributorsById, limit = 4 }) => {
  const avatars = contributors.map(contributor => {
    const { name, id } = contributor;
    const { avatar_url } = contributorsById[id]?.extended_data || {};
    return { url: avatar_url, name };
  });

  return (
    <StyledMembersCell data-testid='members-cell'>
      <MultipleAvatars
        disableTooltipForRest={true}
        avatars={avatars}
        limit={limit}
        size={ICON_SIZES['x-medium']}
      />
    </StyledMembersCell>
  );
};

export default MembersCell;
